import React, { useState } from "react";

import { Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSalesAnalysisRequest,
  CustomerSearchCriteria,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
  SalesAnalysisInquiryCriteriaBean,
} from "../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  DatePickerComponent_adv,
  InputTextbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
class CustomerSalesAnalysis extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer Sales Analysis Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new SalesAnalysisInquiryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: [],
      success_list: [],
      isShowArModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      inquiryData: null,
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      isDisableFields: false,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      isCollapsible_open: true,
      fiscalYears: new Array(),
      baseFiscalLookuphandler: null,
      fiscalLookuphandler: null,
      showAutoCompleteFiscalList: false,
      fiscalPageListForAutoCompleteList: [],
      showAutoCompleteBaseFiscalList: false,
      baseFiscalPageListForAutoCompleteList: [],
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
   
    this.fetchAttributeCache();
    this.initLookupHandlers();
  }
  fetchAttributeCache = () => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let fiscalYears = this.state.fiscalYears;
    if (
      attribute_cache.fiscalYears != null ||
      attribute_cache.fiscalYears != undefined
    ) {
      fiscalYears = attribute_cache.fiscalYears;
    }
    this.setState({
      fiscalYears: fiscalYears,
    });
  };
  initLookupHandlers = () => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let fiscalYears = new Array();
    if (!isEmptyArray(attribute_cache.fiscalYears)) {
      fiscalYears = attribute_cache.fiscalYears;
    }
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let baseFiscalLookuphandler = new GenericAttributeLookupHandler(
      fiscalYears,
      "Base Fiscal"
    );
    this.setState({
      baseFiscalLookuphandler: baseFiscalLookuphandler,
    });
    let fiscalLookuphandler = new GenericAttributeLookupHandler(
      fiscalYears,
      "Fiscal"
    );
    this.setState({
      fiscalLookuphandler: fiscalLookuphandler,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  validateCriteria = (criteria) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (criteria == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(criteria.previousFiscalFromDate)) {
        let errMsg = "Base Fiscal StartDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(criteria.previousFiscalToDate)) {
        let errMsg = "Base Fiscal EndDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(criteria.currentFiscalFromDate)) {
        let errMsg = "StartDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(criteria.currentFiscalToDate)) {
        let errMsg = "EndDate is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = 2;
    let request = new CustomerSalesAnalysisRequest();
    request.criteria = criteria;
    request.input = reportBean;
    let isValid = this.validateCriteria(request.criteria);
    if (isValid) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generating Report...",
      });
      this.generateCustomerAnalysisReport(request);
    }
  };
  generateCustomerAnalysisReport = (request) => {
    if (
      SecurityAccessManager.CustomerSalesAnalysisInquiry_IsAccessible() &&
      SecurityAccessManager.CustomerSalesAnalysisInquiryExcelReport_IsAccessible()
    ) {
      ReportService.getCustomerSalesAnalysisReport(
        request,
        this.loadBouncedCheckPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadBouncedCheckPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
      this.setState({
        isCollapsible_open: false,
        isShowClearCriteriaButton: false,
        isShowResetButton: true,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new SalesAnalysisInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isShowResetButton: false,
      isShowClearCriteriaButton: false,
      isDisableFields: false,
      isCollapsible_open: true,
      showAutoCompleteFiscalList: false,
      fiscalPageListForAutoCompleteList: [],
      showAutoCompleteBaseFiscalList: false,
      baseFiscalPageListForAutoCompleteList: [],
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new SalesAnalysisInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.basefiscalYearCode = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isCollapsible_open: true,
      showAutoCompleteFiscalList: false,
      fiscalPageListForAutoCompleteList: [],
      showAutoCompleteBaseFiscalList: false,
      baseFiscalPageListForAutoCompleteList: [],
    });
    this.hideAlertCallBack();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerCode = customerData.code;
        criteria.customerName = customerData.description;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };
  fiscalOnChange = (e) => {
    let fiscalCode = e.target.value;
    this.state.showAutoCompleteFiscalList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFiscalList;
    if (isEmpty(fiscalCode)) {
      this.state.showAutoCompleteFiscalList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFiscalList;
      let temp_criteria = this.state.criteria;
      temp_criteria.fiscalCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFiscalList: showAutoCompleteList,
        criteria: temp_criteria,
        fiscalPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fiscalCode !== "") {
      this.readFiscalSearchString(fiscalCode);
    }
    if (e.target.name == "fiscalCode") {
      temp_criteria["fiscalCode"] = e.target.value;
      let fiscal_List = this.state.fiscalYears;
      fiscal_List.map((fiscalCode) => {
        if (fiscalCode.code == e.target.value) {
          temp_criteria["fiscalCode"] = fiscalCode.code;
          temp_criteria["currentFiscalFromDate"] = fiscalCode.startDate;
          temp_criteria["currentFiscalToDate"] = fiscalCode.endDate;
          this.state.showAutoCompleteFiscalList = false;
          let showAutoCompleteList = this.state.showAutoCompleteFiscalList;
          this.setState({ showAutoCompleteFiscalList: showAutoCompleteList });
        }
      });
    }
    this.setState({ criteria: temp_criteria });
  };
  readFiscalSearchString(searchString) {
    let fiscalData = this.state.fiscalYears;
    let simpleAutoCompleteList = new Array();
    if (fiscalData.length > 0 && fiscalData != null) {
      fiscalData.map((fiscal) => {
        let simpleItemBean = {
          code: fiscal.code,
          description: fiscal.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (fiscal) =>
        fiscal.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ fiscalPageListForAutoCompleteList: filteredSuggestions });
  }
  fiscalEnterKeyEvent = (e) => {
    let temp_criteria = this.state.criteria;
    let fiscalCode = e.target.value;
    temp_criteria["fiscalCode"] = e.target.value;
    let fiscal_List = this.state.fiscalYears;
    let fiscalBean = null;
    fiscal_List.map((fiscal) => {
      if (fiscal.code == e.target.value) {
        fiscalBean = fiscal;
      }
    });
    if (!isEmpty(fiscalBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.fiscalCode = fiscalBean.code;
      temp_criteria.currentFiscalFromDate = fiscalBean.startDate;
      temp_criteria.currentFiscalToDate = fiscalBean.endDate;
      this.setState({
        criteria: temp_criteria,
        fiscalPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteFiscalList = (showAutoCompleteFiscalList) => {
    this.setState({ showAutoCompleteFiscalList: showAutoCompleteFiscalList });
  };
  baseFiscalOnChange = (e) => {
    let basefiscalYearCode = e.target.value;
    this.state.showAutoCompleteBaseFiscalList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteBaseFiscalList;
    if (isEmpty(basefiscalYearCode)) {
      this.state.showAutoCompleteBaseFiscalList = false;
      let showAutoCompleteList = this.state.showAutoCompleteBaseFiscalList;
      let temp_criteria = this.state.criteria;
      temp_criteria.basefiscalYearCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteBaseFiscalList: showAutoCompleteList,
        criteria: temp_criteria,
        baseFiscalPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && basefiscalYearCode !== "") {
      this.readBaseFiscalSearchString(basefiscalYearCode);
    }
    if (e.target.name == "basefiscalYearCode") {
      temp_criteria["basefiscalYearCode"] = e.target.value;
      let fiscal_List = this.state.fiscalYears;
      fiscal_List.map((basefiscalYearCode) => {
        if (basefiscalYearCode.code == e.target.value) {
          temp_criteria["basefiscalYearCode"] = basefiscalYearCode.code;
          temp_criteria["previousFiscalFromDate"] =
            basefiscalYearCode.startDate;
          temp_criteria["previousFiscalToDate"] = basefiscalYearCode.endDate;
          this.state.showAutoCompleteBaseFiscalList = false;
          let showAutoCompleteList = this.state.showAutoCompleteBaseFiscalList;
          this.setState({
            showAutoCompleteBaseFiscalList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_criteria });
  };
  readBaseFiscalSearchString(searchString) {
    let fiscalData = this.state.fiscalYears;
    let simpleAutoCompleteList = new Array();
    if (fiscalData.length > 0 && fiscalData != null) {
      fiscalData.map((fiscal) => {
        let simpleItemBean = {
          code: fiscal.code,
          description: fiscal.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (fiscal) =>
        fiscal.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      baseFiscalPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  baseFiscalEnterKeyEvent = (e) => {
    let temp_criteria = this.state.criteria;
    let basefiscalYearCode = e.target.value;
    temp_criteria["basefiscalYearCode"] = e.target.value;
    let fiscal_List = this.state.fiscalYears;
    let fiscalBean = null;
    fiscal_List.map((fiscal) => {
      if (fiscal.code == e.target.value) {
        fiscalBean = fiscal;
      }
    });
    if (!isEmpty(fiscalBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.basefiscalYearCode = fiscalBean.code;
      temp_criteria.previousFiscalFromDate = fiscalBean.startDate;
      temp_criteria.previousFiscalToDate = fiscalBean.endDate;
      this.setState({
        criteria: temp_criteria,
        baseFiscalPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteBaseFiscalList = (showAutoCompleteBaseFiscalList) => {
    this.setState({
      showAutoCompleteBaseFiscalList: showAutoCompleteBaseFiscalList,
    });
  };
  render() {
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          customerCodeRef={this.customerCodeRef}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          showHideSecondHeader={this.showHideSecondHeader}
          fiscalOnChange={this.fiscalOnChange}
          fiscalEnterKeyEvent={this.fiscalEnterKeyEvent}
          displayAutoCompleteFiscalList={this.displayAutoCompleteFiscalList}
          baseFiscalOnChange={this.baseFiscalOnChange}
          baseFiscalEnterKeyEvent={this.baseFiscalEnterKeyEvent}
          displayAutoCompleteBaseFiscalList={
            this.displayAutoCompleteBaseFiscalList
          }
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  let criteria = props.criteria;
  let customerLookupHandler = props.customerLookupHandler;
  const customerCodeRef = props.customerCodeRef;
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>Base FiscalYear</FormLabel>
        </Col>
        <Col sm="2">
          {/* <InputTextbox
            name="fiscalCode"
            onChange={onChange}
            value={criteria.baseFiscalCode}
            disabled={props.isDisableFields}
          /> */}
          <InputTextbox
            name="basefiscalYearCode"
            onChange={props.baseFiscalOnChange}
            value={criteria.basefiscalYearCode}
            lookupRequired={true}
            lookupHandler={props.baseFiscalLookuphandler}
            enterKeyEventHandler={props.baseFiscalEnterKeyEvent}
            autoCompleteListData={props.baseFiscalPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={props.displayAutoCompleteBaseFiscalList}
            showAutoCompleteList={props.showAutoCompleteBaseFiscalList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>BaseFiscal StartDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="previousFiscalFromDate"
            value={criteria.previousFiscalFromDate}
            onChange={onChange}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>BaseFiscal StopDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="previousFiscalToDate"
            value={criteria.previousFiscalToDate}
            onChange={onChange}
            disabled={true}
          />
        </Col>
        <Col>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => props.showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            <FormLabel>FiscalYear</FormLabel>
          </Col>
          <Col sm="2">
            {/* <InputTextbox
              name="fiscalCode"
              onChange={onChange}
              value={criteria.FiscalCode}
              disabled={props.isDisableFields}
            /> */}
            <InputTextbox
              name="fiscalCode"
              onChange={props.fiscalOnChange}
              value={criteria.fiscalCode}
              lookupRequired={true}
              lookupHandler={props.fiscalLookuphandler}
              enterKeyEventHandler={props.fiscalEnterKeyEvent}
              autoCompleteListData={props.fiscalPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={props.displayAutoCompleteFiscalList}
              showAutoCompleteList={props.showAutoCompleteFiscalList}
              disabled={props.isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Start Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="currentFiscalFromDate"
              value={criteria.currentFiscalFromDate}
              onChange={onChange}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>End Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="currentFiscalToDate"
              value={criteria.currentFiscalToDate}
              onChange={onChange}
              disabled={true}
            />
          </Col>
        </Row>
      )}
      {props.isCollapsible_open && (
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={customerCodeRef}
              name="customerCode"
              onChange={customerCodeOnChange}
              value={criteria.customerCode}
              lookupRequired={true}
              lookupHandler={customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={customerCodeEnterKeyEventHandler}
              autoCompleteListData={props.customerPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteList}
              showAutoCompleteList={props.showAutoCompleteCustomerList}
              disabled={props.isDisableFields}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="customerName"
              onChange={onChange}
              value={criteria.customerName}
              disabled={true}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
function CustomerSalesAnalysisInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerSalesAnalysis {...props} name="" /> <br />
    </div>
  );
}

export default CustomerSalesAnalysisInquiry;
